/**
 * HAVN Bundle Builder
 * Handles variant selection modal, bundle state, and countdown timer
 */

const HAVN_Bundle = {
  state: {
    selectedProducts: [],
    currentProductId: null,
    selectedVariantId: null,
    currentImageIndex: 0,
    maxProducts: 3,
    timerInterval: null,
    timerSeconds: 600
  },

  init() {
    console.log('HAVN Bundle initialized');
    console.log('Products loaded:', Object.keys(window.HAVN_BUNDLE_PRODUCTS || {}).length);
    this.updateTracker();
  },

  isProductSelected(productId) {
    return this.state.selectedProducts.some(p => p.productId == productId);
  },

  toggleImageView(view) {
    console.log('Toggling to view:', view);

    const container = document.getElementById('toggle-container');
    const buttons = document.querySelectorAll('.bundle-builder__toggle-btn');
    
    if (view === 'model') {
      container.classList.remove('product-active');
      container.classList.add('model-active');
    } else {
      container.classList.remove('model-active');
      container.classList.add('product-active');
    }

    buttons.forEach(btn => {
      if (btn.dataset.view === view) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    const cards = document.querySelectorAll('.bundle-card');
    cards.forEach(card => {
      const modelImage = card.querySelector('.bundle-card__image--model');
      const productImage = card.querySelector('.bundle-card__image--product');

      if (view === 'model') {
        if (modelImage) modelImage.classList.add('active');
        if (productImage) productImage.classList.remove('active');
      } else {
        if (modelImage) modelImage.classList.remove('active');
        if (productImage) productImage.classList.add('active');
      }
    });
  },

  // Filter Modal Functions
  filterState: {
    availability: 'all',
    type: 'all-types'
  },

  openFilterModal() {
    const modal = document.getElementById('filter-modal');
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  },

  closeFilterModal() {
    const modal = document.getElementById('filter-modal');
    modal.classList.remove('active');
    document.body.style.overflow = '';
  },

  selectFilter(category, value) {
    this.filterState[category] = value;

    const options = document.querySelectorAll(`[data-category="${category}"]`);
    options.forEach(option => {
      const filterValue = option.getAttribute('data-filter');
      if (filterValue === value) {
        option.classList.add('active');
      } else {
        option.classList.remove('active');
      }
    });

    console.log('Filter selected:', category, value);
  },

  clearFilters() {
    this.filterState = {
      availability: 'all',
      type: 'all-types'
    };

    const options = document.querySelectorAll('.filter-modal__option');
    options.forEach(option => {
      const filterValue = option.getAttribute('data-filter');
      if (filterValue === 'all' || filterValue === 'all-types') {
        option.classList.add('active');
      } else {
        option.classList.remove('active');
      }
    });

    this.applyFilters();
    console.log('Filters cleared');
  },

  quickClearFilters() {
    this.clearFilters();
  },

  updateFilterButton() {
    const button = document.getElementById('filter-button');
    const buttonText = document.getElementById('filter-button-text');
    
    if (!button || !buttonText) return;

    const activeFilters = [];
    
    if (this.filterState.availability !== 'all') {
      activeFilters.push('In Stock');
    }
    
    if (this.filterState.type !== 'all-types') {
      const typeName = this.filterState.type.charAt(0).toUpperCase() + this.filterState.type.slice(1);
      activeFilters.push(typeName);
    }

    if (activeFilters.length > 0) {
      button.classList.add('active');
      buttonText.innerHTML = `${activeFilters.join(', ')} <span class="bundle-builder__filter-clear" onclick="event.stopPropagation(); HAVN_Bundle.quickClearFilters();">×</span>`;
    } else {
      button.classList.remove('active');
      buttonText.textContent = 'Filter';
    }
  },

  applyFilters() {
    console.log('Applying filters:', this.filterState);
    
    const cards = document.querySelectorAll('.bundle-card');
    
    cards.forEach(card => {
      let showCard = true;
      const handle = card.dataset.productHandle.toLowerCase();

      if (this.filterState.availability === 'in-stock') {
        if (card.classList.contains('out-of-stock')) {
          showCard = false;
        }
      }

      if (this.filterState.type !== 'all-types') {
        if (this.filterState.type === 'accessories') {
          if (!handle.includes('pendant') && !handle.includes('bracelet')) {
            showCard = false;
          }
        } else {
          if (!handle.includes(this.filterState.type)) {
            showCard = false;
          }
        }
      }

      if (showCard) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });

    this.updateFilterButton();
    this.closeFilterModal();
  },

  openModal(productId) {
    if (this.state.selectedProducts.length >= this.state.maxProducts) {
      return;
    }

    if (this.isProductSelected(productId)) {
      return;
    }

    const product = window.HAVN_BUNDLE_PRODUCTS[productId];
    if (!product) {
      console.error('Product not found:', productId);
      return;
    }

    this.state.currentProductId = productId;
    this.state.selectedVariantId = null;
    this.state.currentImageIndex = 0;

    const productImages = this.getProductImages(productId);

    const modalBody = document.getElementById('modal-body');
    modalBody.innerHTML = `
      <div class="bundle-modal__image-container">
        <img 
          class="bundle-modal__image" 
          id="modal-image"
          src="${productImages[0]}" 
          alt="${product.title}"
        >
        ${productImages.length > 1 ? `
          <button class="bundle-modal__nav bundle-modal__nav--prev" onclick="HAVN_Bundle.prevModalImage()">‹</button>
          <button class="bundle-modal__nav bundle-modal__nav--next" onclick="HAVN_Bundle.nextModalImage()">›</button>
          <div class="bundle-modal__image-dots">
            ${productImages.map((_, index) => `
              <div class="bundle-modal__dot ${index === 0 ? 'active' : ''}" onclick="HAVN_Bundle.goToModalImage(${index})"></div>
            `).join('')}
          </div>
        ` : ''}
      </div>
      <div class="bundle-modal__info">
        <h2 class="bundle-modal__title">${product.title}</h2>
        
        <div class="bundle-modal__variants">
          <label class="bundle-modal__variants-label">Select Length:</label>
          <div class="bundle-modal__variants-grid">
            ${product.variants.map(variant => `
              <button 
                class="bundle-modal__variant-chip ${!variant.available ? 'disabled' : ''}"
                data-variant-id="${variant.id}"
                ${!variant.available ? 'disabled' : ''}
                onclick="HAVN_Bundle.selectVariant(${variant.id})"
              >
                ${variant.title}
              </button>
            `).join('')}
          </div>
        </div>

        <button 
          class="bundle-modal__cta" 
          id="modal-add-btn"
          disabled
          onclick="HAVN_Bundle.addToBundle()"
        >
          Add to Bundle
        </button>
      </div>
    `;

    const modal = document.getElementById('bundle-modal');
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  },

  getProductImages(productId) {
    const product = window.HAVN_BUNDLE_PRODUCTS[productId];
    if (!product) return [];
    return product.images && product.images.length > 0 ? product.images : [product.image];
  },

  prevModalImage() {
    const productImages = this.getProductImages(this.state.currentProductId);
    this.state.currentImageIndex = (this.state.currentImageIndex - 1 + productImages.length) % productImages.length;
    this.updateModalImage();
  },

  nextModalImage() {
    const productImages = this.getProductImages(this.state.currentProductId);
    this.state.currentImageIndex = (this.state.currentImageIndex + 1) % productImages.length;
    this.updateModalImage();
  },

  goToModalImage(index) {
    this.state.currentImageIndex = index;
    this.updateModalImage();
  },

  updateModalImage() {
    const productImages = this.getProductImages(this.state.currentProductId);
    const modalImage = document.getElementById('modal-image');
    const dots = document.querySelectorAll('.bundle-modal__dot');

    if (modalImage) {
      modalImage.src = productImages[this.state.currentImageIndex];
    }

    dots.forEach((dot, index) => {
      if (index === this.state.currentImageIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  },

  closeModal() {
    const modal = document.getElementById('bundle-modal');
    modal.classList.remove('active');
    document.body.style.overflow = '';
    
    this.state.currentProductId = null;
    this.state.selectedVariantId = null;
  },

  selectVariant(variantId) {
    this.state.selectedVariantId = variantId;

    const chips = document.querySelectorAll('.bundle-modal__variant-chip');
    chips.forEach(chip => {
      chip.classList.remove('selected');
      if (chip.dataset.variantId == variantId) {
        chip.classList.add('selected');
      }
    });

    const addBtn = document.getElementById('modal-add-btn');
    if (addBtn) {
      addBtn.disabled = false;
    }
  },

  addToBundle() {
    if (!this.state.selectedVariantId) return;

    const product = window.HAVN_BUNDLE_PRODUCTS[this.state.currentProductId];
    const variant = product.variants.find(v => v.id == this.state.selectedVariantId);

    if (!variant) {
      console.error('Variant not found');
      return;
    }

    this.state.selectedProducts.push({
      productId: product.id,
      variantId: variant.id,
      title: product.title,
      variantTitle: variant.title,
      image: product.image
    });

    console.log('Added to bundle:', this.state.selectedProducts);

    this.updateCardStates();
    this.closeModal();
    this.updateTracker();

    if (this.state.selectedProducts.length === this.state.maxProducts) {
      this.handleBundleComplete();
    }
  },

  addDirectly(productId, variantId) {
    if (this.state.selectedProducts.length >= this.state.maxProducts) {
      return;
    }

    if (this.isProductSelected(productId)) {
      return;
    }

    const product = window.HAVN_BUNDLE_PRODUCTS[productId];
    if (!product) {
      console.error('Product not found:', productId);
      return;
    }

    const variant = product.variants.find(v => v.id == variantId);
    if (!variant) {
      console.error('Variant not found');
      return;
    }

    this.state.selectedProducts.push({
      productId: product.id,
      variantId: variant.id,
      title: product.title,
      variantTitle: variant.title,
      image: product.image
    });

    console.log('Added to bundle (direct):', this.state.selectedProducts);

    this.updateCardStates();
    this.updateTracker();

    if (this.state.selectedProducts.length === this.state.maxProducts) {
      this.handleBundleComplete();
    }
  },

  removeFromBundle(index) {
    this.state.selectedProducts.splice(index, 1);
    console.log('Removed from bundle:', this.state.selectedProducts);
    this.updateCardStates();
    this.updateTracker();
  },

  updateCardStates() {
    const cards = document.querySelectorAll('.bundle-card');
    
    cards.forEach(card => {
      const productId = card.dataset.productId;
      const isSelected = this.isProductSelected(productId);
      const button = card.querySelector('.bundle-card__cta');
      
      if (isSelected) {
        card.classList.add('selected');
        if (button) {
          button.textContent = 'Added!';
        }
      } else {
        card.classList.remove('selected');
        if (button) {
          const productVariants = window.HAVN_BUNDLE_PRODUCTS[productId]?.variants;
          if (productVariants && productVariants.length === 1) {
            button.textContent = 'Add to Bundle';
          } else {
            button.textContent = 'Select Length';
          }
        }
      }
    });
  },

  updateTracker() {
    const tracker = document.getElementById('bundle-tracker');
    const thumbnails = document.getElementById('tracker-thumbnails');
    const pricing = document.getElementById('tracker-pricing');
    const comparePrice = document.getElementById('tracker-compare-price');
    const cta = document.getElementById('tracker-cta');

    if (!tracker || !thumbnails || !pricing || !comparePrice || !cta) return;

    const count = this.state.selectedProducts.length;

    if (count > 0) {
      tracker.classList.add('active');
      pricing.classList.add('active');
    } else {
      tracker.classList.remove('active');
      pricing.classList.remove('active');
    }

    thumbnails.innerHTML = '';
    
    let totalComparePrice = 0;

    this.state.selectedProducts.forEach((item, index) => {
      const thumb = document.createElement('div');
      thumb.className = 'bundle-tracker__thumb';
      thumb.innerHTML = `
        <img class="bundle-tracker__thumb-image" src="${item.image}" alt="${item.title}">
        <button class="bundle-tracker__thumb-remove" onclick="HAVN_Bundle.removeFromBundle(${index})">×</button>
      `;
      thumbnails.appendChild(thumb);

      const product = window.HAVN_BUNDLE_PRODUCTS[item.productId];
      if (product) {
        const variant = product.variants.find(v => v.id == item.variantId);
        if (variant && variant.compare_at_price) {
          totalComparePrice += variant.compare_at_price;
        }
      }
    });

    for (let i = count; i < this.state.maxProducts; i++) {
      const empty = document.createElement('div');
      empty.className = 'bundle-tracker__empty';
      empty.textContent = i + 1;
      thumbnails.appendChild(empty);
    }

    const formattedPrice = (totalComparePrice / 100).toFixed(2);
    comparePrice.textContent = `$${formattedPrice}`;

    const remaining = this.state.maxProducts - count;
    if (remaining > 0) {
      cta.disabled = true;
      cta.textContent = `Choose ${remaining} More`;
    } else {
      cta.disabled = false;
      cta.textContent = 'Checkout Now';
    }

    console.log('Tracker update:', count, '/', this.state.maxProducts, 'selected');
    console.log('Total compare price:', formattedPrice);
  },

  handleBundleComplete() {
    console.log('Bundle complete! Showing popup with timer.');
    
    const popup = document.getElementById('bundle-complete-popup');
    if (popup) {
      popup.classList.add('active');
      document.body.style.overflow = 'hidden';
      this.startTimer();
    }
  },

  startTimer() {
    this.state.timerSeconds = 600;
    
    if (this.state.timerInterval) {
      clearInterval(this.state.timerInterval);
    }

    this.updateTimerDisplay();

    this.state.timerInterval = setInterval(() => {
      this.state.timerSeconds--;
      
      if (this.state.timerSeconds <= 0) {
        clearInterval(this.state.timerInterval);
        this.state.timerSeconds = 0;
      }
      
      this.updateTimerDisplay();
    }, 1000);
  },

  updateTimerDisplay() {
    const display = document.getElementById('timer-display');
    if (!display) return;

    const minutes = Math.floor(this.state.timerSeconds / 60);
    const seconds = this.state.timerSeconds % 60;
    
    display.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
    
    const timerEl = document.getElementById('bundle-timer');
    if (this.state.timerSeconds < 120 && timerEl) {
      timerEl.style.background = '#ffebee';
      timerEl.style.borderColor = '#ef5350';
      timerEl.style.color = '#c62828';
    }
  },

  closeCompletePopup() {
    const popup = document.getElementById('bundle-complete-popup');
    if (popup) {
      popup.classList.remove('active');
      document.body.style.overflow = '';
    }
    
    if (this.state.timerInterval) {
      clearInterval(this.state.timerInterval);
      this.state.timerInterval = null;
    }
  },

  proceedToCheckout() {
    this.handleTrackerCTA();
  },

  async handleTrackerCTA() {
    if (this.state.selectedProducts.length < this.state.maxProducts) {
      return;
    }

    const popupButton = document.querySelector('.bundle-complete-popup.active .bundle-complete-popup__cta');
    const trackerButton = document.getElementById('tracker-cta');
    const button = popupButton || trackerButton;
    
    if (!button) return;

    const originalContent = button.innerHTML;
    button.disabled = true;
    button.innerHTML = `
      <div style="
        width: 20px;
        height: 20px;
        border: 3px solid rgba(255,255,255,0.3);
        border-top-color: #fff;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
      "></div>
      <style>
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      </style>
    `;

    try {
      // Step 1: Selectively clear the cart — remove everything EXCEPT gift products.
      // We cannot use /cart/clear.js because that also wipes Dr. Free Gift's product,
      // and we redirect to checkout before it has time to re-add it.
      // Instead: read the cart, set quantity=0 for all non-gift items only.
      const GIFT_HANDLES_TO_KEEP = [
        'mystery-free-gift-chain',
        'docapp-free-gift-free-mystery-gift-chain-6134'
      ];

      const existingCart = await fetch('/cart.js').then(r => r.json());
      const itemsToRemove = {};
      existingCart.items.forEach(function(item) {
        if (!GIFT_HANDLES_TO_KEEP.includes(item.handle)) {
          itemsToRemove[item.key] = 0;
        }
      });
      if (Object.keys(itemsToRemove).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: itemsToRemove })
        });
      }
      console.log('✅ Cart cleared (gifts preserved)');

      // Step 2: Add all 3 bundle products — this MUST succeed
      const bundleItems = this.state.selectedProducts.map(item => ({
        id: item.variantId,
        quantity: 1,
        properties: {
          '_Bundle': '3 Chains for $99',
          '_Bundle_Item': 'true'
        }
      }));

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: bundleItems })
      });
      if (!addResponse.ok) throw new Error('Failed to add bundle products');
      console.log('✅ Bundle products added');

      // Step 3: Always add the bundle mystery gift directly.
      // The Dr. Free Gift app "Based on discount code HAVN_FREE" goal must be TURNED OFF
      // in the Dr. Free Gift app settings to prevent duplicates.
      // This JS is now the single source of truth for the gift in all flows.
      try {
        const FREE_GIFT_VARIANT_ID = window.HAVN_FREE_GIFT_VARIANT_ID || '51195487125817';
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: FREE_GIFT_VARIANT_ID,
              quantity: 1,
              properties: { '_Free_Gift': 'Bundle Bonus', '_Gift': 'true' }
            }]
          })
        });
        console.log('✅ Bundle gift added');
      } catch (giftError) {
        console.warn('⚠️ Gift add failed (non-fatal):', giftError);
      }

      // Step 4: Set flags and redirect — this always runs
      try { sessionStorage.setItem('havn_bundle_gift_added', 'true'); } catch(e) {}
      try { sessionStorage.setItem('havn_gift_readded', 'true'); } catch(e) {}

      console.log('✅ Redirecting to checkout...');
      window.location.href = '/checkout';

    } catch (error) {
      // Only hits here if Step 1 or Step 2 failed
      console.error('❌ Checkout error:', error);
      button.disabled = false;
      button.innerHTML = originalContent;
      alert('There was an error adding your items. Please try again.');
    }
  }
};

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => HAVN_Bundle.init());
} else {
  HAVN_Bundle.init();
}

// Handle escape key to close modals
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    HAVN_Bundle.closeModal();
    HAVN_Bundle.closeCompletePopup();
    HAVN_Bundle.closeFilterModal();
  }
});